export default __webpack_public_path__ + "static/media/litho-templates-library-06.c7c2643f.jpg";